/**
 * Global Modal Styles
 * Centralized modal styling configuration
 */

export const MODAL_BLUR_STYLES = {
  mask: {
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
  },
} as const;
